
import { Component, Prop, Vue } from "vue-property-decorator";

import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { AdditionalServiceCategory } from "@/models/additional-service/AdditionalServiceCategory";

@Component({
  components: { ConfirmDlg }
})
export default class AdditionalServiceCategories extends Vue {
  @Prop({ default: new AdditionalServiceCategory() }) additionalServiceCategories!: AdditionalServiceCategory;

  public dialog = false;
  public addCategoryVisible = false;
  public editMode = false;
  public loading = false;

  public categoryName: string;
  public readonly categoryNameRules: unknown = [
    (category: string) => !!category.trim() || this.$i18n.messages[this.$i18n.locale]['PremiumServiceCategories.DimensionNameIsRequired'],
    (category: string) =>
      !this.additionalServiceCategories.categories.includes(
        category.trim()
      ) || this.$i18n.messages[this.$i18n.locale]['PremiumServiceCategories.ThisDimensionAlreadyExist']
  ];

  private categoryToEdit: string;

  public get serviceCategories(): string[] {
    this.categoryName = "";
    this.editMode = false;
    this.addCategoryVisible = false;
    return this.additionalServiceCategories ? this.additionalServiceCategories.categories || [] : [];
  }

  public changeVisibilityOfAddForm(): void {
    this.addCategoryVisible = !this.addCategoryVisible;
    this.categoryName = "";
    this.editMode = false;
  }

  public async saveChanges() {
    if (!this.categoryName) {
      this.dialog = false;
      return;
    }

    const categoryName = this.categoryName;
    const isValid = (this.$refs.form as any).validate();

    if (!isValid) return;

    this.loading = true;

    const requestData = this.additionalServiceCategories;

    if (this.editMode) {
      const indexToRemove = requestData.categories.indexOf(
        this.categoryToEdit
      );

      this.additionalServiceCategories.categories.splice(
        indexToRemove,
        1,
        categoryName
      );
    } else {
      requestData.categories.push(categoryName);
    }

    Promise.all([
      await this.updateCategories(categoryName),
      await this.$store.dispatch("upsertAdditionalServiceCategories", requestData)
    ]).then(() => {
      this.$emit("refreshServices");
      this.loading = false;
    })
  }

  async updateCategories(categoryName) {
    if(this.categoryToEdit) {
      await this.$store.dispatch("updateServicesRequestsCategory", {
        oldCategory: this.categoryToEdit,
        newCategory: categoryName
      })

      await this.$store.dispatch("updateAdditionalServicesCategory", {
        oldCategory: this.categoryToEdit,
        newCategory: categoryName
      })
    }
  }

  public editCategory(category: string): void {
    this.addCategoryVisible = true;
    this.editMode = true;
    this.categoryToEdit = category;
    this.categoryName = category;
  }

  public async deleteCategory(category: string, refs) {
    const servicesCount = this.$store.state.additionalServicesModule.additionalServices.filter(x => x.category === category).length;

    refs.confirmationModal
      .open(
        null,
        (this.$i18n.messages[this.$i18n.locale]['PremiumServiceCategories.DeleteMessage'] as string).replace('[number of services]',servicesCount),
        false
      )
      .then(async response => {
        if (response.agree) {
          const requestData = this.additionalServiceCategories;
          const indexToRemove = requestData.categories.indexOf(category);

          if (indexToRemove !== -1) {
            this.additionalServiceCategories.categories.splice(
              indexToRemove,
              1
            );

            Promise.all([
              this.$store.dispatch("upsertAdditionalServiceCategories", requestData),
              this.$store.dispatch("deleteCategoryFromServices", category),
              this.$store.dispatch("deleteCategoryFromRequests", category)
            ]).then(() => {
              this.$emit("refreshServices");
            });
          }
        }
      });
  }
}
